import React from 'react'
import styled from 'styled-components'

const Styles = {
    HoverCard: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;

    width: ${({width}) => width };

    padding: ${({padding}) => padding}; 
    cursor: pointer;
    border-radius: ${({theme}) => theme.borderRadius};
    box-shadow: 0 3px 15px ${({ shadowColor }) => shadowColor}40;
    margin: 1rem;
    background-color: ${({ bgColor }) => bgColor};
    color: ${({ textColor }) => textColor};
    &:hover {
      opacity: 0.9;
      transform: scale(0.98);
  }
    `,
}

const FloatButton = ({textColor = 'black', shadowColor = '#000000', bgColor='#ffffff',padding='1rem 2rem', width = '100%', handleClick, children}) => {
  return (
   <Styles.HoverCard textColor={textColor} onClick={handleClick} width={width} shadowColor={shadowColor} bgColor={bgColor} padding={padding}
   > 
       {children}
   </Styles.HoverCard>
  )
}

export default FloatButton
